import { Stack } from '@mantine/core'
import type { PropertyWithRelations, VisitWithRelations } from '@markku/types'
import { DocumentsCard } from './DocumentsCard'
import { CompletedTasksList } from './CompletedTasksList'
import { DefectsNotesCard } from './DefectsNotesCard'
import { PropertySurveyCard } from './PropertySurveyCard'
import { VisitNotesCard } from './VisitNotesCard'
import { VisitPaymentCard } from './VisitPaymentCard'
import { VisitSummaryCard } from './VisitSummaryCard'

interface PastVisitProps {
  visit: VisitWithRelations
  property?: PropertyWithRelations
  hidePayment?: boolean
}

export function PastVisit({ visit, property, hidePayment }: PastVisitProps) {
  const isSurvey = visit.eventType === 'survey'

  return (
    <Stack gap="lg">
      <VisitSummaryCard visit={visit} />
      {!hidePayment && visit.status === 'completed' && (
        <VisitPaymentCard visit={visit} />
      )}
      <VisitNotesCard visit={visit} />
      <DefectsNotesCard visit={visit} />
      {isSurvey && <PropertySurveyCard visit={visit} />}
      <DocumentsCard visit={visit} property={property} />
      <CompletedTasksList visit={visit} />
    </Stack>
  )
}
